import React from "react";
import App from "./App";

import { createRoot } from "react-dom/client";

const rootElement = document.getElementById("root");
const landingElement = document.getElementById("landing");

if (landingElement) {
	// Mostrar a landing page ao carregar a aplicação
	landingElement.style.display = "block";
	rootElement.style.display = "none";
}

const root = createRoot(rootElement); 
root.render(<App tab="order" />);